import React, { Component } from 'react';
import { Select } from 'antd';
import api from "../../../../services/api";
import { observer, inject } from 'mobx-react';

const { Option } = Select;

@inject('commonStore')
@observer
class DealerSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealers: [],
      selected: []
    }
  }

  componentDidMount() {
    api('getAllDealers').then(dealers =>
      this.setState({
        dealers: dealers
      })
    );
  }

  handleChange = (value) => {
    console.log(`selected ${value}`);
    if(this.state.selected.includes('all')) {
      this.setState({
        selected: value.filter(item => item !== 'all')
      },() => {
        this.props.commonStore.setSelectedDealers(this.state.selected);
      });
    }
    else{
      this.setState({
        selected: value.includes('all') ? 'all' : value
      }, () => {
        this.props.commonStore.setSelectedDealers(this.state.selected);
      });

    }

  };

  render() {
    return (
      <Select
        mode="multiple"
        style={{ minWidth: '300px' }}
        placeholder="Seleziona dealer"
        defaultValue={[]}
        onChange={this.handleChange}
        value={this.state.selected}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        <Option key='all'>Tutti</Option>
        {this.state.dealers.map(dealer =>
            <Option key={dealer.id}>{dealer.name}</Option>
        )}
      </Select>
    );
  }
}

export default DealerSelector
